// Soft two-tone notification chime (Slack-style) generated with Web Audio so
// no audio asset is needed. Best effort: browsers block audio until the user
// has interacted with the page, so failures are silently ignored.
export function playNudgeSound() {
  try {
    const Ctx =
      window.AudioContext || (window as any).webkitAudioContext;
    if (!Ctx) return;
    const ctx: AudioContext = new Ctx();
    if (ctx.state === "suspended") {
      // No user gesture yet — audio would be blocked.
      ctx.close();
      return;
    }
    const note = (freq: number, at: number, dur: number) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      const start = ctx.currentTime + at;
      gain.gain.setValueAtTime(0, start);
      gain.gain.linearRampToValueAtTime(0.12, start + 0.015);
      gain.gain.exponentialRampToValueAtTime(0.001, start + dur);
      osc.connect(gain).connect(ctx.destination);
      osc.start(start);
      osc.stop(start + dur + 0.05);
    };
    note(987.77, 0, 0.25); // B5
    note(659.25, 0.13, 0.35); // E5
    setTimeout(() => ctx.close(), 1000);
  } catch {
    /* ignore — sound is a nicety, never break the page over it */
  }
}
